import YandexMap from './YandexMap';

export default YandexMap;
